// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "common/src/Router.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as TbPage13 from "../team-planner13/TbPage13.bs.js";
import * as TbPage14 from "../team-planner14/TbPage14.bs.js";
import * as TbPage46 from "../team-planner46/TbPage46.bs.js";
import * as TbUtils13 from "../team-planner13/TbUtils13.bs.js";
import * as TbUtils46 from "../team-planner46/TbUtils46.bs.js";
import * as ReactDnd from "react-dnd";
import * as ReactDndTouchBackend from "react-dnd-touch-backend";

function TeamPlannerPage(Props) {
  var initialBoardOpt = Props.initialBoard;
  var locale = Props.locale;
  var exalteds = Props.exalteds;
  var initialBoard = initialBoardOpt !== undefined ? initialBoardOpt : "";
  TbAtoms.useInit(undefined);
  var match = React.useState(function () {
        if (initialBoard.startsWith(TbUtils46.version)) {
          return /* Set46 */9;
        } else if (initialBoard.startsWith(TbUtils13.version)) {
          return /* Set13 */5;
        } else {
          return /* Set14 */6;
        }
      });
  var setSet = match[1];
  Router.use(undefined);
  var onGoToSet13 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set13 */5;
                      }));
        }), []);
  var onGoToSet14 = React.useCallback((function (param) {
          return Curry._1(setSet, (function (param) {
                        return /* Set14 */6;
                      }));
        }), []);
  var tmp;
  switch (match[0]) {
    case /* Set13 */5 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set13 */5, React.createElement(TbPage13.make, {
                      onGoToSet6: onGoToSet14,
                      locale: locale,
                      board: initialBoard,
                      exalteds: exalteds
                    }), undefined));
        break;
    case /* Set14 */6 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set14 */6, React.createElement(TbPage14.make, {
                      onGoToSet6: onGoToSet13,
                      locale: locale,
                      board: initialBoard,
                      exalteds: exalteds
                    }), undefined));
        break;
    case /* Set9 */0 :
    case /* Set95 */1 :
    case /* Set10 */2 :
    case /* Set11 */3 :
    case /* Set12 */4 :
    case /* Set36 */7 :
    case /* Set56 */8 :
        tmp = null;
        break;
    case /* Set46 */9 :
        tmp = React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set46 */9, React.createElement(TbPage46.make, {
                      onGoToSet6: onGoToSet13,
                      locale: locale,
                      board: initialBoard,
                      exalteds: exalteds
                    }), undefined));
        break;
    
  }
  return React.createElement(ReactDnd.DndProvider, {
              backend: ReactDndTouchBackend.TouchBackend,
              options: {
                enableMouseEvents: true,
                enableKeyboardEvents: true,
                enableHoverOutsideTarget: true
              },
              children: React.createElement(AdLayout.make, {
                    children: tmp
                  })
            });
}

var make = TeamPlannerPage;

export {
  make ,
  
}
/* react Not a pure module */
